export enum FileTypeEnum
{
    Employee = 1,
    Project = 2,
    ExpenseData = 3,
    TimeTracking = 4,
    ExpenseSurvey = 5,
    TimeSurvey = 6,
    ClientUser = 7,
    PreparedByClient = 8,
    AgileAnalyzer = 9,
    SurveyCompleteInstructions = 10,
    ExpenseDataMapError = 11,
    BusinessComponent=15
}
